export const BorrowerStatus = {
	InComplete: 'InComplete',
	Pending: 'Pending',
	ApprovedByAM: 'Compliance',
	ApprovedByCO: 'Approved',
	Archived: 'Archived',
};
